// MA6: the two maps remain here until their new Admin homes are drawn.
import { ActionButton } from '../parts/index.js';
import { useState } from 'react';
import type { Store } from '../api.js';
import { BillingMap } from '../billing/BillingMap.js';
import { Snowflake } from './Snowflake.js';
import './admin.css';

type Tab = 'snowflake' | 'billing';
function tabFromLocation(): Tab | null {
  const tab = new URLSearchParams(window.location.search).get('tab');
  return tab === 'snowflake' || tab === 'billing' ? tab : null;
}
export function AdminConsole({ store }: { store: Store }) {
  const [tab, setTab] = useState(tabFromLocation);
  const choose = (next: Tab) => {
    setTab(next);
    const url = new URL(window.location.href);
    url.searchParams.set('tab', next);
    window.history.replaceState(window.history.state, '', url);
  };
  // App redirects retired addresses before mounting. Never draw a closed tab even in isolation.
  if (!tab) return null;
  return <>
    <div className="admin-tabs" role="tablist" aria-label="Admin">
      <ActionButton reading type="button" role="tab" aria-selected={tab === 'snowflake'} onClick={() => choose('snowflake')}>Snowflake</ActionButton>
      <ActionButton reading type="button" role="tab" aria-selected={tab === 'billing'} onClick={() => choose('billing')}>Billing</ActionButton>
    </div>
    {tab === 'snowflake' ? <Snowflake store={store} /> : <BillingMap store={store} />}
  </>;
}
